// extracted by mini-css-extract-plugin
export var quantityInput = "_nl-0";